import WebApi from './WebApi';
import portalRoutes from './portal-settings';
const jsRoutes = window.jsRoutes;

class PlayWebApi extends WebApi {
  getLoginStatus() {
    return jsRoutes.controllers.LoginController.getLoginStatus();
  }

  /**
   * 注销
   * @return {{ajax, url}}
   */
  logout() {
    return jsRoutes.controllers.defaults.Auth.logout();
  }

  /**
   * 获取 JWT token
   * @returns {{ajax, url}}
   */
  getJwtToken(type) {
    return jsRoutes.controllers.LoginController.getJwtToken(type);
  }

  /**
   * 获取用户信息
   * @param userId
   * @return {{ajax: (function(): Promise<never>), url: string}}
   */
  getUser(userId) {
    return jsRoutes.controllers.UserController.getUser(userId);
  }

  /**
   * 获取地域列表
   * @return {{ajax, url}}
   */
  getAreaList() {
    return jsRoutes.controllers.UtilityController.getAreaList();
  }

  /**
   * 获取行业列表
   * @return {{ajax, url}}
   */
  getIndustryList() {
    return jsRoutes.controllers.UtilityController.getIndustryList();
  }

  /**
   * 获取推广目标列表
   * @return {{ajax, url}}
   */
  getPromotedObjectList() {
    return jsRoutes.controllers.UtilityController.getPromotedObjectList();
  }

  /**
   * 获取线索来源列表
   * @return {{ajax, url}}
   */
  getSourceTypeList() {
    return jsRoutes.controllers.UtilityController.getSourceTypeList();
  }

  /**
   * 获取线索标签配置
   * @return {{ajax, url}}
   */
  getSourceTypeTag() {
    return jsRoutes.controllers.UtilityController.getSourceTypeTag();
  }

  /**
   * 获取服务商信息
   * @param agencyId
   * @param needAdditionalInfo
   * @return {{ajax, url}}
   */
  getAgency(agencyId, needAdditionalInfo) {
    return jsRoutes.controllers.AgencyController.getAgency(agencyId, needAdditionalInfo);
  }

  /**
   * 获取服务商信息
   * @return {{ajax, url}}
   */
  getAgencyList() {
    return jsRoutes.controllers.AgencyController.getAgencyList();
  }

  /**
   * 关联服务商
   * @return {{ajax, url}}
   */
  bindAgency() {
    return jsRoutes.controllers.AgencyController.bindAgency();
  }

  /**
   * 校验代理商 ID 有效性
   * @return {{ajax, url}}
   */
  checkAgency() {
    return jsRoutes.controllers.AgencyController.checkAgency();
  }

  /**
   * 获取代理商名称
   * @return {{ajax, url}}
   */
  getCsAgency() {
    return jsRoutes.controllers.AgencyController.getCsAgency();
  }

  /**
   * 修改代理商
   * @return {{ajax, url}}
   */
  updateAgency() {
    return jsRoutes.controllers.AgencyController.updateAgency();
  }

  /**
   * 修改代理商状态
   * @return {{ajax, url}}
   */
  updateAgencyStatus(agencyId, status) {
    return jsRoutes.controllers.AgencyController.updateAgencyStatus(agencyId, status);
  }
  /**
   * 获取所有BM列表
   * @return {{ajax, url}}
   */
  getBmList() {
    return jsRoutes.controllers.AgencyController.getBmList();
  }

  /**
   * 用户企微解绑
   * @return {{ajax, url}}
   */
  unbindWechatWork() {
    return jsRoutes.controllers.EmployeeController.unbindWechatWork();
  }

  /**
   * 切换服务商
   * @param agencyId
   * @return {{ajax, url}}
   */
  switchAgency(agencyId) {
    return jsRoutes.controllers.LoginController.switchAgency(agencyId);
  }

  /**
   * 获取架构树
   * @return {{ajax, url}}
   */
  getOrganizationTree() {
    return jsRoutes.controllers.OrganizationController.getOrganizationTree();
  }

  /**
   * 获取用户所属团队列表
   */
  getEmployeeWorkingTeams(employeeId) {
    return jsRoutes.controllers.EmployeeController.getEmployeeWorkingTeams(employeeId);
  }

  /**
   * 获取权限列表
   * @return {{ajax, url}}
   */
  getPrivilegeList() {
    return jsRoutes.controllers.UtilityController.getPrivilegeList();
  }

  /**
   * 获取用户权限列表
   * @param employeeId
   * @returns {*}
   */
  getEmployeePermission(employeeId) {
    return jsRoutes.controllers.EmployeeController.getEmployeePermission(employeeId);
  }

  /**
   * 新增或修改代理商首选项数据
   * @return {{ajax, url}}
   */
  editAgencyPreference() {
    return jsRoutes.controllers.PreferenceController.editAgencyPreference();
  }

  /**
   * 获取员工列表
   * @return {{ajax, url}}
   */
  getEmployeeUserList() {
    return jsRoutes.controllers.EmployeeController.getEmployeeUserList();
  }

  /**
   * 获取员工
   * @return {{ajax, url}}
   */
  getEmployeeUser(employeeId) {
    return jsRoutes.controllers.EmployeeController.getEmployeeUser(employeeId);
  }

  /**
   * 拉取用户坐席信息
   * @return {{ajax, url}}
   */
  getEmployeeSeatInfo(employeeId) {
    return jsRoutes.controllers.EmployeeController.getEmployeeSeatInfo(employeeId);
  }

  /**
   * 释放用户坐席
   * @return {{ajax, url}}
   */
  releaseEmployeeSeat(employeeId) {
    return jsRoutes.controllers.EmployeeController.releaseEmployeeSeat(employeeId);
  }

  /**
   * 获取当前员工
   * @return {{ajax, url}}
   */
  getCurrentEmployeeUser() {
    return jsRoutes.controllers.EmployeeController.getCurrentEmployeeUser();
  }

  /**
   * 批量交接
   */
  batchTransferOwner() {
    return jsRoutes.controllers.EmployeeController.batchTransferOwner();
  }

  /**
   * 获取批量交接的数据量
   */
  getBatchTransferDetail(oldOwnerId) {
    return jsRoutes.controllers.EmployeeController.getBatchTransferDetail(oldOwnerId);
  }

  /**
   * 基础查询
   * @return {{ajax, url}}
   */
  basicSearch() {
    return jsRoutes.controllers.LeadController.basicSearch();
  }

  /**
   * 搜索线索
   * @return {{ajax, url}}
   */
  searchLead() {
    return jsRoutes.controllers.LeadController.search();
  }

  /**
   * 参数校验
   * @return {{ajax, url}}
   */
  companyVerify() {
    return jsRoutes.controllers.LeadController.companyVerify();
  }

  /**
   * 参数校验(只校验格式)
   * @return {{ajax, url}}
   */
  companyNameVerify() {
    return jsRoutes.controllers.LeadController.checkSpecialCharacters();
  }

  /**
   * 创建线索
   * @return {{ajax, url}}
   */
  createLead() {
    return jsRoutes.controllers.LeadController.create();
  }

  /**
   * 清洗线索
   * @return {{ajax, url}}
   */
  cleanLead(leadId) {
    return jsRoutes.controllers.LeadController.cleaningLead(leadId);
  }

  /**
   * 获取线索详情
   * @return {{ajax, url}}
   */
  getLead(leadId, agencyId) {
    return jsRoutes.controllers.LeadController.get(leadId, agencyId);
  }

  /**
   * 更新线索信息
   * @return {{ajax, url}}
   */
  updateLead(leadId) {
    return jsRoutes.controllers.LeadController.update(leadId);
  }

  /**
   * 线索分配
   * @return {{ajax, url}}
   */
  assignLeads() {
    return jsRoutes.controllers.LeadController.assignLeads();
  }
  /**
   * 转为商机
   * @return {{ajax, url}}
   */
  toPotential(leadId) {
    return jsRoutes.controllers.LeadController.turn2Potential(leadId);
  }

  /**
   * @description 线索日志
   *
   */
  searchLog() {
    return jsRoutes.controllers.LeadController.searchLog();
  }

  /**
   * 搜索商机
   * @return {{ajax, url}}
   */
  searchPotential() {
    return jsRoutes.controllers.PotentialController.search();
  }

  /**
   * 通过关键字（leadId、companyName）搜索商机
   * @return {{ajax, url}}
   */
  searchPotentialByKeyword(keyword) {
    return jsRoutes.controllers.PotentialController.searchByKeyword(keyword);
  }

  /**
   * 获取商机
   * @param leadId
   * @return {{ajax, url}}
   */
  getPotential(leadId, agencyId) {
    return jsRoutes.controllers.PotentialController.get(leadId, agencyId);
  }

  /**
   * 更新商机信息
   * @return {{ajax, url}}
   */
  updatePotential(leadId) {
    return jsRoutes.controllers.PotentialController.update(leadId);
  }

  /**
   * 商机分配
   * @return {{ajax, url}}
   */
  assignPotentials() {
    return jsRoutes.controllers.PotentialController.assignPotentials();
  }

  /**
   * 释放商机到公海池
   * @return {{ajax, url}}
   */
  releasePotentials() {
    return jsRoutes.controllers.PotentialController.batchFall2HighSeas();
  }

  /**
   * 公海申领
   * @return {{ajax, url}}
   */
  obtainPotentials() {
    return jsRoutes.controllers.PotentialController.obtain();
  }

  /**
   * 搜索订单
   * @return {{ajax, url}}
   */
  searchOrder() {
    return jsRoutes.controllers.OrderController.search();
  }

  /**
   * 提单
   * @return {{ajax, url}}
   */
  createOrder() {
    return jsRoutes.controllers.OrderController.create();
  }
  /**
   * 更新订单中线索信息
   * @return {{ajax, url}}
   */
  updateOrderLeadInfo(leadId) {
    return jsRoutes.controllers.OrderController.updateLeadInfo(leadId);
  }
  /**
   * 编辑提单
   * @return {{ajax, url}}
   */
  updateOrder(leadId) {
    return jsRoutes.controllers.OrderController.update(leadId);
  }

  /**
   * 获取订单
   * @return {{ajax, url}}
   */
  getOrder(leadId, agencyId) {
    return jsRoutes.controllers.OrderController.get(leadId, agencyId);
  }

  /**
   * 释放订单到公海池
   * @return {{ajax, url}}
   */
  releaseOrders() {
    return jsRoutes.controllers.OrderController.batchFall2HighSeas();
  }

  /**
   * 获取外勤单列表
   * @return {{ajax, url}}
   */
  getOutsideList() {
    return jsRoutes.controllers.OutsideTicketController.search();
  }

  /**
   * 获取外勤单列表的数量
   * @return {{ajax, url}}
   */
  getOutsideCount() {
    return jsRoutes.controllers.OutsideTicketController.count();
  }

  /**
   * 下载外勤单列表
   * @return {{ajax, url}}
   */
  downloadOutsideExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadOutsideExcel();
  }

  /**
   * 新建外勤单
   * @return {{ajax, url}}
   */
  createOutsideTicket() {
    return jsRoutes.controllers.OutsideTicketController.create();
  }

  /**
   * 更新外勤单
   * @return {{ajax, url}}
   */
  updateOutsideTicket(outsideTicketId) {
    return jsRoutes.controllers.OutsideTicketController.update(outsideTicketId);
  }

  /**
   * 获取外勤单详情
   * @return {{ajax, url}}
   */
  getOutsideTicket(outsideTicketId) {
    return jsRoutes.controllers.OutsideTicketController.get(outsideTicketId);
  }
  /**
   * is 审核
   * @return {{ajax, url}}
   */
  insideReview() {
    return jsRoutes.controllers.OutsideTicketController.insideReview();
  }
  /**
   * 回填
   * @return {{ajax, url}}
   */
  backFill() {
    return jsRoutes.controllers.OutsideTicketController.backFill();
  }
  /**
   * 撤回
   * @return {{ajax, url}}
   */
  outsideWithdraw() {
    return jsRoutes.controllers.OutsideTicketController.outsideWithdraw();
  }
  /**
   * 关闭
   * @return {{ajax, url}}
   */
  outsideClose() {
    return jsRoutes.controllers.OutsideTicketController.outsideClose();
  }
  /**
   * 是否接受外勤单
   * @return {{ajax, url}}
   */
  outsideAccept() {
    return jsRoutes.controllers.OutsideTicketController.outsideAccept();
  }
  /**
   * os 审核
   * @return {{ajax, url}}
   */
  outsideReview() {
    return jsRoutes.controllers.OutsideTicketController.outsideReview();
  }
  /**
   * 获取外勤联系人
   * @return {{ajax, url}}
   */
  getOutsideContactList(outsideTicketId) {
    return jsRoutes.controllers.OutsideTicketController.getContactList(outsideTicketId);
  }
  /**
   * 获取外勤记录
   * @return {{ajax, url}}
   */
  getOutsideTicketRecordList(outsideTicketId) {
    return jsRoutes.controllers.OutsideTicketController.getOutsideTicketRecordList(outsideTicketId);
  }
  /**
   * 订单到款审核
   * @returns {*}
   */
  reviewOrderPayment() {
    return jsRoutes.controllers.OrderController.reviewOrderPayment();
  }

  /**
   * 订单提交上线
   * @returns {*}
   */
  submitOrderOnline() {
    return jsRoutes.controllers.OrderController.submitOrderOnline();
  }

  /**
   * 订单提交上线审核
   * @returns {*}
   */
  reviewOrderEffective() {
    return jsRoutes.controllers.OrderController.submitOnlineReview();
  }

  /**
   * 转移订单
   * @return {{ajax, url}}
   */
  assignOrder() {
    return jsRoutes.controllers.OrderController.assignOrders();
  }

  /**
   * 新增广点通广告主
   * @return {{ajax, url}}
   */
  addAdvertisingAccount() {
    return jsRoutes.controllers.RegistrationTicketController.create();
  }

  /**
   * 更新广点通广告主
   * @return {{ajax, url}}
   */
  updateAdvertisingAccount() {
    return jsRoutes.controllers.RegistrationTicketController.update();
  }

  /**
   * 获取广点通广告主详情
   * @return {{ajax, url}}
   */
  getAdvertisingDetail(registrationTicketId) {
    return jsRoutes.controllers.RegistrationTicketController.getRegistrationDetail(registrationTicketId);
  }

  /**
   * 获取客户行业资质体系结构
   * @return {{ajax, url}}
   */
  getIndustryInfo(industryId) {
    return jsRoutes.controllers.RegistrationTicketController.getIndustryCertificationsHierarchyList(industryId);
  }

  /**
   * 上传图片
   * @return {{ajax, url}}
   */
  uploadImage(request) {
    return jsRoutes.controllers.RegistrationTicketController.upload(request);
  }

  /**
   * 根据UID 获取开户信息
   * @return {{ajax, url}}
   */
  getAdvertiserInfo(uid) {
    return jsRoutes.controllers.RegistrationTicketController.getAdvertiserInfo(uid);
  }

  /**
   * 撤回
   * @return {{ajax, url}}
   */
  registrationWithdraw() {
    return jsRoutes.controllers.RegistrationTicketController.withdraw();
  }
  /**
   * 关闭
   * @return {{ajax, url}}
   */
  registrationClose() {
    return jsRoutes.controllers.RegistrationTicketController.close();
  }

  /**
   * @description: 开户申请
   */
  createSelfOpen() {
    return jsRoutes.controllers.RegistrationTicketController.createSelfOpen();
  }

  /**
   * @description: 修改开户申请
   */
  updateSelfOpen() {
    return jsRoutes.controllers.RegistrationTicketController.updateSelfOpen();
  }

  /**
   * @description: 广点通完成开户
   */
  gdtOpen() {
    return jsRoutes.controllers.RegistrationTicketController.gdtOpen();
  }

  /**
   * @description: MP客保申请
   */
  customerProtection() {
    return jsRoutes.controllers.RegistrationTicketController.customerProtection();
  }

  /**
   * @description: 查询MP客保申请状态
   */
  searchProtectionInfo() {
    return jsRoutes.controllers.RegistrationTicketController.searchProtectionInfo();
  }

  /**
   * 获取客户信息
   * @param customerId
   * @return {{ajax: (function(): Promise<never>), url: string}}
   */
  getCustomer(customerId) {
    return jsRoutes.controllers.CustomerController.getCustomer(customerId);
  }

  /**
   * 检查客户信息
   * @return {{ajax: (function(): Promise<never>), url: string}}
   */
  checkCustomer() {
    return jsRoutes.controllers.CustomerController.check();
  }

  /**
   * 获取联系人
   * @param leadId
   * @return {{ajax, url}}
   */
  getContactList(leadId, agencyId) {
    return jsRoutes.controllers.CustomerController.getContactList(leadId, agencyId);
  }

  /**
   * 获取跟进记录列表
   * @param leadId
   * @return {{ajax, url}}
   */
  getActionRecordList(leadId, agencyId) {
    return jsRoutes.controllers.ActionController.getActionRecordList(leadId, agencyId);
  }

  /**
   * 添加跟进记录
   * @param leadId
   * @return {{ajax, url}}
   */
  addActionRecord(leadId) {
    return jsRoutes.controllers.ActionController.createActionRecord(leadId);
  }

  /**
   * 更新跟进记录
   * @param leadId
   * @param recordId
   * @return {{ajax, url}}
   */
  updateActionRecord(leadId, recordId) {
    return jsRoutes.controllers.ActionController.updateActionRecord(leadId, recordId);
  }
  /**
   * 呼出电话号码
   * @return {{ajax: (function(): Promise<never>), url: string}}
   */
  dialOutCheck() {
    return jsRoutes.controllers.CallCenterController.dialOutCheck();
  }

  /**
   * 呼出电话号码
   * @return {{ajax: (function(): Promise<never>), url: string}}
   */
  dialOut() {
    return jsRoutes.controllers.CallCenterController.dialOut();
  }

  /**
   * 呼入电话号码检查
   */
  dialInCheck() {
    return jsRoutes.controllers.CallCenterController.dialInCheck();
  }

  /**
   * 呼入电话号码
   */
  dialInLead() {
    return jsRoutes.controllers.CallCenterController.dialInLead();
  }

  /**
   * 呼入电话跟进记录
   */
  dialInTraceCalling() {
    return jsRoutes.controllers.CallCenterController.dialInTraceCalling();
  }

  /**
   * 呼入白名单
   */
  getCustomerProtectionWhiteList() {
    return jsRoutes.controllers.CallCenterController.getCustomerProtectionWhiteList();
  }

  /**
   * 总机号码列表
   */
  listDisplayNumber() {
    return jsRoutes.controllers.CallCenterController.listDisplayNumber();
  }

  /**
   * 拉取代理商首选项数据
   * @return {{ajax, url}}
   */
  getAgencyPreference(agencyId) {
    return jsRoutes.controllers.PreferenceController.getAgencyPreference(agencyId);
  }

  /**
   * 获取坐席角色列表
   * @return {{ajax, url}}
   */
  getSeatRoles() {
    return jsRoutes.controllers.EmployeeController.getSeatRoles();
  }

  /**
   * 获取坐席技能列表
   * @return {{ajax, url}}
   */
  getSkillGroups(callCenterId) {
    return jsRoutes.controllers.EmployeeController.getSkillGroups(callCenterId);
  }

  /**
   * 创建用户
   * @return {{ajax, url}}
   */
  createEmployee(agencyId, isAdminister) {
    return jsRoutes.controllers.EmployeeController.createEmployee(agencyId, isAdminister);
  }

  /**
   * 修改用户
   * @return {{ajax, url}}
   */
  updateEmployee() {
    return jsRoutes.controllers.EmployeeController.updateEmployee();
  }

  /**
   * 修改当前用户分机
   * @return {{ajax, url}}
   */
  updateCurrentEmployeeExtensionNumber() {
    return jsRoutes.controllers.EmployeeController.updateCurrentEmployeeExtensionNumber();
  }

  /**
   * 修改用户状态
   * @return {{ajax, url}}
   */
  updateEmployeeStatus(employeeId, status, validPeriodStartTime, validPeriodEndTime) {
    return jsRoutes.controllers.EmployeeController.updateEmployeeStatus(employeeId, status, validPeriodStartTime, validPeriodEndTime);
  }

  /**
   * 查询座席信息
   * @return {{ajax, url}}
   */
  getSeatUseDetails() {
    return jsRoutes.controllers.EmployeeController.getSeatUseDetails();
  }

  /**
   * 获取座席ID
   * @return {{ajax, url}}
   */
  automaticallyAssignSeatNo(agencyId, idCard) {
    return jsRoutes.controllers.EmployeeController.automaticallyAssignSeatNo(agencyId, idCard);
  }

  /**
   * 跟进线索/商机
   * @returns {{ajax, url}}
   */
  traceCalling() {
    return jsRoutes.controllers.CallCenterController.traceCalling();
  }

  /**
   * 获取坐席信息
   * @returns {{ajax, url}}
   */
  getSeatInfo() {
    return jsRoutes.controllers.CallCenterController.getSeatInfo();
  }

  /**
   * 校验呼叫中心外部 ID 有效性
   * @returns {{ajax, url}}
   */
  checkCallCenterId(agencyId, externalId, vendor) {
    return jsRoutes.controllers.CallCenterController.checkCallCenterId(agencyId, externalId, vendor);
  }

  /**
   * 校验坐席 ID 有效性
   * @returns {{ajax, url}}
   */
  checkSeatNo(agencyId, callCenterId, seatNo) {
    return jsRoutes.controllers.CallCenterController.checkSeatNo(agencyId, callCenterId, seatNo);
  }

  /**
   * 校验分机前缀有效性
   * @returns {{ajax, url}}
   */
  checkSipPrefix(callCenterId, sipPrefix) {
    return jsRoutes.controllers.CallCenterController.checkSipPrefix(callCenterId, sipPrefix);
  }

  fetchStatusBar() {
    return jsRoutes.controllers.CallSessionController.statusBar();
  }

  queryImportLeadResult() {
    return jsRoutes.controllers.LeadController.queryImportLeadResult();
  }

  getLeadCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.getLeadCustomizedViewFields(employeeId);
  }

  getPotentialCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.getPotentialCustomizedViewFields(employeeId);
  }

  getOrderCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.getOrderCustomizedViewFields(employeeId);
  }

  saveLeadCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.saveLeadCustomizedViewFields(employeeId);
  }

  savePotentialCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.savePotentialCustomizedViewFields(employeeId);
  }

  saveOrderCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.saveOrderCustomizedViewFields(employeeId);
  }

  getConversionCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.getConversionCustomizedViewFields(employeeId);
  }

  getConversionRateCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.getConversionRateCustomizedViewFields(employeeId);
  }

  getEfficiencyReportCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.getEfficiencyReportCustomizedViewFields(employeeId);
  }

  saveConversionReportCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.saveConversionReportCustomizedViewFields(employeeId);
  }

  saveConversionRateReportCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.saveConversionRateReportCustomizedViewFields(employeeId);
  }

  saveEfficiencyReportCustomizedViewFields(employeeId) {
    return jsRoutes.controllers.EmployeePreferenceController.saveEfficiencyReportCustomizedViewFields(employeeId);
  }

  downloadLeadExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadLeadExcel();
  }

  downloadPotentialExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadPotentialExcel();
  }

  downloadOrderExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadOrderExcel();
  }

  downloadUserExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadUserExcel();
  }

  downloadAllUserExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadAllAgencyUserExcel();
  }

  downloadConversionReport() {
    return jsRoutes.controllers.DownloadExcelController.downloadConversionReportExcel();
  }

  downloadConversionRateReport() {
    return jsRoutes.controllers.DownloadExcelController.downloadConversionRateReportExcel();
  }

  queryDownloadResult(uuid) {
    return jsRoutes.controllers.DownloadExcelController.queryDownloadResult(uuid);
  }

  getBlackListRecords() {
    return jsRoutes.controllers.CallCenterController.getBlackListRecords();
  }

  addBlackListRecord() {
    return jsRoutes.controllers.CallCenterController.addBlackListRecord();
  }

  releaseBlackListRecord() {
    return jsRoutes.controllers.CallCenterController.releaseBlackListRecord();
  }

  batchReleaseBlackListRecord() {
    return jsRoutes.controllers.CallCenterController.batchReleaseBlackListRecord();
  }

  checkBlackListRecord() {
    return jsRoutes.controllers.CallCenterController.checkBlackListRecord();
  }

  downloadBlackExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadBlackExcel();
  }

  searchFeature() {
    return jsRoutes.controllers.FeatureController.search();
  }

  saveFeature() {
    return jsRoutes.controllers.FeatureController.save();
  }

  searchReportTrafficDetail() {
    return jsRoutes.controllers.CallSessionController.search();
  }

  downloadReportTrafficDetail() {
    return jsRoutes.controllers.DownloadExcelController.downloadSessionExcel();
  }

  searchReportTrafficDaily() {
    return jsRoutes.controllers.CallSessionController.searchStatistics();
  }

  downloadReportTrafficDaily() {
    return jsRoutes.controllers.DownloadExcelController.downloadSessionStatisticsExcel();
  }

  searchReportCost() {
    return jsRoutes.controllers.CostReportController.search();
  }

  searchReportCharge() {
    return jsRoutes.controllers.CostReportController.searchChargeReport();
  }

  downloadReportCost() {
    return jsRoutes.controllers.DownloadExcelController.downloadCostReport();
  }

  downloadRechargeReport() {
    return jsRoutes.controllers.DownloadExcelController.downloadRechargeReport();
  }

  getTeamCallData() {
    return jsRoutes.controllers.WorkbenchController.getCallData();
  }

  /**
   * 销售看板
   * @returns {{ajax, url}}
   */
  getSaleModular() {
    return jsRoutes.controllers.WorkbenchController.getSaleModular();
  }

  /**
   * 待办事项
   * @returns {{ajax, url}}
   */
  getSaleModularPendIng() {
    return jsRoutes.controllers.WorkbenchController.getSaleModularPendIng();
  }

  getTeamSalesData() {
    return jsRoutes.controllers.SalesDataController.teamSalesData();
  }

  /**
   * 新增IS审核人
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  addInsideReviewer() {
    return jsRoutes.controllers.OutsideTicketController.addInsideReviewer();
  }

  /**
   * 获取IS审核人
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  getInsideReviewers() {
    return jsRoutes.controllers.OutsideTicketController.getInsideReviewers();
  }

  /**
   * 删除IS审核人
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  deleteInsideReviewer() {
    return jsRoutes.controllers.OutsideTicketController.deleteInsideReviewer();
  }

  /**
   * 新增外勤审核人
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  addOutsideReviewer() {
    return jsRoutes.controllers.OutsideTicketController.addOutsideReviewer();
  }

  /**
   * 获取外勤审核人
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  getOutsideReviewers() {
    return jsRoutes.controllers.OutsideTicketController.getOutsideReviewers();
  }

  /**
   * 删除外勤审核人
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  deleteOutsideReviewer() {
    return jsRoutes.controllers.OutsideTicketController.deleteOutsideReviewer();
  }
  /**
   * 转移外勤单
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  outsideTransfer() {
    return jsRoutes.controllers.OutsideTicketController.transfer();
  }
  /**
   * 查询业绩分析列表
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  getPerformanceList() {
    return jsRoutes.controllers.PerformanceAnalysisController.search();
  }
  /**
   * 下载业绩分析列表
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  downloadPerformanceReport() {
    return jsRoutes.controllers.DownloadExcelController.downloadPerformanceReport();
  }
  /**
   * 删除线索
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  deleteLead(leadId) {
    return jsRoutes.controllers.LeadController.delete(leadId);
  }
  /**
   * 删除商机
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  deletePotential(potentialId) {
    return jsRoutes.controllers.PotentialController.delete(potentialId);
  }
  /**
   * 删除订单
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  deleteOrder(orderId) {
    return jsRoutes.controllers.OrderController.delete(orderId);
  }

  /**
   * 获取下单产品列表
   */
  getOrderingProductList() {
    return jsRoutes.controllers.UtilityController.getOrderingProductList();
  }

  /**
   * 获取渠道经理列表
   */
  queryChannelManagerList() {
    return jsRoutes.controllers.ChannelManagerController.list();
  }
  queryChannelManager(oaAccount) {
    return jsRoutes.controllers.ChannelManagerController.get(oaAccount);
  }
  /**
   * 修改渠道经理列表
   */
  updateChannelManager() {
    return jsRoutes.controllers.ChannelManagerController.update();
  }
  /**
   * 获取业务分析转化量列表
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  searchConversion() {
    return jsRoutes.controllers.BusinessAnalysisController.searchConversionReport();
  }

  /**
   * 获取业务分析转化率列表
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  searchConversionRate(orderId) {
    return jsRoutes.controllers.BusinessAnalysisController.searchConversionRateReport();
  }

  /**
   * 获取效能评估列表
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  searchEfficiencyReport() {
    return jsRoutes.controllers.BusinessAnalysisController.searchEfficiencyReport();
  }

  /**
   * 下载效能评估列表
   * @returns {{ajax: (function(): Promise<never>), url: string}}
   */
  downloadEfficiencyReport() {
    return jsRoutes.controllers.DownloadExcelController.downloadEfficiencyReportExcel();
  }

  /**
   * 获取录音 url
   */
  getRecord() {
    return jsRoutes.controllers.CallCenterController.getRecord();
  }

  /**
   * 获取附件
   */
  listAttachments(agencyId, attachmentIds) {
    return jsRoutes.controllers.AttachmentController.get(agencyId, attachmentIds);
  }

  /**
   * 搜索待分配开户单
   * @return {{ajax, url}}
   */
  searchUnassignedList() {
    return portalRoutes.controllers.RegistrationTicketController.searchUnassignedList();
  }
  /**
   * 搜索开户单列表
   * @return {{ajax, url}}
   */
  searchRegisterAccountList() {
    return portalRoutes.controllers.RegistrationTicketController.searchUnregisteredList();
  }
  /**
   * 获取开户人列表
   * @return {{ajax, url}}
   */
  getOperatorList() {
    return portalRoutes.controllers.RegistrationTicketController.getRegistrationOperator();
  }

  /**
   * 分配开户人/审批拒绝
   * @return {{ajax, url}}
   */
  assignReview() {
    return portalRoutes.controllers.RegistrationTicketController.assignReview();
  }

  /**
   * 开户拒绝
   * @return {{ajax, url}}
   */
  registerReviewReject() {
    return portalRoutes.controllers.RegistrationTicketController.registerReviewReject();
  }

  /**
   * 开户
   * @return {{ajax, url}}
   */
  register() {
    return portalRoutes.controllers.RegistrationTicketController.register();
  }

  /**
   * 编辑开户
   * @return {{ajax, url}}
   */
  gdtRegistrationUpdate() {
    return portalRoutes.controllers.RegistrationTicketController.gdtRegistrationUpdate();
  }

  /**
   * 获取开户单操作记录
   * @return {{ajax, url}}
   */
  getRegistrationRecordList(id) {
    return portalRoutes.controllers.RegistrationTicketController.getRegistrationRecordList(id);
  }

  /**
   * 转移开户单
   * @return {{ajax, url}}
   */
  registrationTransfer() {
    return jsRoutes.controllers.RegistrationTicketController.transfer();
  }

  /**
   * 获取广点通广告主详情
   * @return {{ajax, url}}
   */
  getRegistrationDetail(registrationTicketId) {
    return portalRoutes.controllers.RegistrationTicketController.getRegistrationDetail(registrationTicketId);
  }

  /**
   * 获取投放信息详情
   * @return {{ajax, url}}
   */
  getAdvertisingInfo(registrationTicketId) {
    return portalRoutes.controllers.RegistrationTicketController.getAdvertisingInfoDetail(registrationTicketId);
  }

  /** * 取消微信预授权
   * @return {{ajax, url}}
   */
  cancelWechatAccount() {
    return portalRoutes.controllers.RegistrationTicketController.cancelWechatAccount();
  }

  /**
   * 更新投放信息详情
   * @return {{ajax, url}}
   */
  updateAdvertisingInfo() {
    return portalRoutes.controllers.RegistrationTicketController.updateAdvertisingInfo();
  }

  /**
   * 微信预授权
   * @return {{ajax, url}}
   */
  addWechatAccount(data) {
    return jsRoutes.controllers.RegistrationTicketController.registerWechatAccount(data);
  }

  /**
   * @description: 修改开户人
   */
  updateRegistrar() {
    return jsRoutes.controllers.RegistrationTicketController.updateRegistrar();
  }

  /**
   * 获取联系人
   * @param leadId
   * @return {{ajax, url}}
   */
  getPortalContactList(leadId) {
    return portalRoutes.controllers.CustomerController.getContactList(leadId);
  }

  /**
   * 获取服务商ID
   * @return {{ajax, url}}
   */
  getAgencyAccountList(platform) {
    return portalRoutes.controllers.AgencyController.getAgencyAccountList(platform);
  }

  /**
   * 线索公海申领
   * @return {{ajax, url}}
   */
  obtainLead() {
    return jsRoutes.controllers.LeadController.obtain();
  }

  /**
   * 线索释放到公海
   * @return {{ajax, url}}
   */
  releaseLeads() {
    return jsRoutes.controllers.LeadController.batchFall2HighSeas();
  }

  /**
   * 订单到款驳回
   * @returns {*}
   */
  rejectOrderPayment() {
    return jsRoutes.controllers.OrderController.rejectOrderPayment();
  }

  /**
   * 获取增补联系人
   * @param leadId
   * @return {{ajax, url}}
   */
  getAdditionalContactList(leadId) {
    return jsRoutes.controllers.CustomerController.getAdditionalContactList(leadId);
  }
  /**
   * 更新增补信息
   * @param leadId
   * @return {{ajax, url}}
   */
  updateRemind(leadId) {
    return jsRoutes.controllers.LeadController.updateRemind(leadId);
  }

  /**
   * 更新活动提醒状态
   * @return {{ajax, url}}
   */
  updateActivityRemind() {
    return jsRoutes.controllers.LeadController.updateActivityRemind();
  }

  /**
   * 获取座席ID
   */
  findAllLeadLabels() {
    return jsRoutes.controllers.LeadLabelController.findAllLeadLabels();
  }

  /**
   * 删除线索标签
   */
  deleteLeadLabel() {
    return jsRoutes.controllers.LeadLabelController.deleteLeadLabel();
  }

  /**
   * 修改线索标签
   */
  updateLeadLabel() {
    return jsRoutes.controllers.LeadLabelController.updateLeadLabel();
  }

  /**
   * 添加线索标签
   */
  addLeadLabel() {
    return jsRoutes.controllers.LeadLabelController.addLeadLabel();
  }

  /**
   * 新增模板
   */
  addRecordTemplate() {
    return jsRoutes.controllers.RecordTemplateController.add();
  }

  /**
   * 删除模板
   */
  deleteRecordTemplate() {
    return jsRoutes.controllers.RecordTemplateController.delete();
  }

  /**
   * 修改模板
   */
  updateRecordTemplate() {
    return jsRoutes.controllers.RecordTemplateController.update();
  }

  /**
   * 查询当前用户的模板
   */
  findRecordTemplate() {
    return jsRoutes.controllers.RecordTemplateController.findByEmployeeIdAndAgencyId();
  }

  /**
   * 获取角色列表
   * @return {{ajax, url}}
   */
  getRoleList() {
    return jsRoutes.controllers.RoleController.getRoleList();
  }

  getRoleListIfNeed() {
    return this.getRoleList().when((state) => !state.roleList || !state.roleList.query);
  }

  /**
   * 获取职务可选项
   * @return {{ajax, url}}
   */
  getTitleList() {
    return jsRoutes.controllers.OrganizationController.getTitleList();
  }

  getTitleListIfNeed() {
    return this.getTitleList().when((state) => !state.titleList || !state.titleList.query);
  }

  /**
   * 获取职位可选项
   * @return {{ajax, url}}
   */
  getPositionList() {
    return jsRoutes.controllers.OrganizationController.getPositionList();
  }

  getPositionListIfNeed() {
    return this.getPositionList().when((state) => !state.positionList || !state.positionList.query);
  }

  /**
   * 获取雇员绑定的角色列表
   * @return {{ajax, url}}
   */
  getBoundRoleList(userId) {
    return jsRoutes.controllers.RoleController.getBoundRoleList(userId);
  }

  /**
   * @description 批量分配角色
   * @returns {*}
   */
  bindRoles() {
    return jsRoutes.controllers.EmployeeController.bindRoles();
  }

  /**
   * @description 员工入职
   * @param employeeId
   * @param teamId
   * @param begin
   * @param end
   * @returns {*}
   */
  reEntry(employeeId, teamId, begin, end) {
    return jsRoutes.controllers.EmployeeController.reEntry(employeeId, teamId, begin, end);
  }

  /**
   * @description 员工离职
   * @param employeeId
   * @param end
   * @returns {*}
   */
  resign(employeeId, end) {
    return jsRoutes.controllers.EmployeeController.resign(employeeId, end);
  }

  /**
   * @description 离职操作前检查员工状态
   * @param employeeId
   * @returns {*}
   */
  checkOwnerStat(employeeId) {
    return jsRoutes.controllers.EmployeeController.checkOwnerStat(employeeId);
  }
  /**
   * @description 检查是否点击过弹窗，支持不同 type
   *
   */
  checkWindow() {
    return jsRoutes.controllers.EmployeeController.checkWindow();
  }

  /**
   * @description 记录点击弹窗行为
   *
   */
  clickUpdate() {
    return jsRoutes.controllers.EmployeeController.clickUpdate();
  }

  /**
   * @description 开通附近推
   *
   */
  openUnibd() {
    return jsRoutes.controllers.EmployeeController.openUnibd();
  }

  /**
   * @description 渠道码启停
   *
   */
  updateSalesPerson() {
    return jsRoutes.controllers.EmployeeController.updateSalesPerson();
  }

  /**
   * @description 获取渠道码
   *
   */
  getSalesPersonQrCode() {
    return jsRoutes.controllers.EmployeeController.getSalesPersonQrCode();
  }

  /**
   * @description 附近推列表
   *
   */
  getUnibdList() {
    return jsRoutes.controllers.UnibdController.getUnibdList();
  }

  /**
   * @description 附近推列表下载
   *
   */
  downloadUnibdExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadUnibdExcel();
  }

  /**
   * @description 查看购买套餐
   *
   */
  getLocalBusinessCampaignList() {
    return jsRoutes.controllers.UnibdController.getLocalBusinessCampaignList();
  }

  /**
   * @description 购买套餐下载
   *
   */
  downloadAdvertisePackageExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadAdvertisePackageExcel();
  }

  /**
   * @description 查看退款流水
   *
   */
  getRefundApplyList() {
    return jsRoutes.controllers.UnibdController.getRefundApplyList();
  }

  /**
   * @description 退款流水列表下载
   *
   */
  downloadRefundApplyExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadRefundApplyExcel();
  }

  /**
   * @description 线索活动管理详情
   *
   */
  activitySearchList(leadId, pageSize, pageIndex) {
    return portalRoutes.controllers.ActivityController.searchList(leadId, pageSize, pageIndex);
  }

  /**
   * OA域活动列表
   * @returns {{ajax, url}}
   */
  searchListInOa() {
    return jsRoutes.controllers.ActivityController.search();
  }

  /**
   * 推送短信号码包查询
   * @returns {{ajax, url}}
   */
  getSmsActivityInfo() {
    return jsRoutes.controllers.ActivityController.getSmsActivityInfo();
  }

  /**
   * 提交号码包
   * @returns {{ajax, url}}
   */
  submitNumber() {
    return jsRoutes.controllers.ActivityController.submitNumber();
  }

  /**
   * @description: 拉取渠道订单列表
   */
  channelOrderSearch() {
    return jsRoutes.controllers.OrderController.channelOrderSearch();
  }

  /**
   * @description: 创建渠道订单
   */
  channelOrderSingleCreate() {
    return jsRoutes.controllers.OrderController.channelOrderSingleCreate();
  }

  /**
   * @description: 更新渠道订单
   */
  updateChannelOrder(leadId) {
    return jsRoutes.controllers.OrderController.updateChannelOrder(leadId);
  }

  /**
   * @description: 渠道订单导入
   */
  channelOrderImportResult() {
    return jsRoutes.controllers.OrderController.channelOrderImportResult();
  }

  /**
   * @description: 下载渠道订单
   */
  downloadChannelOrderExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadChannelOrderExcel();
  }

  /**
   * @description: 渠道订单详情
   */
  channelOrderDetail(leadId) {
    return jsRoutes.controllers.OrderController.channelOrderDetail(leadId);
  }

  /**
   * @description: 分配运营
   */
  advertiserOperatorUpdate() {
    return jsRoutes.controllers.OrderController.advertiserOperatorUpdate();
  }

  /**
   * @description: 拉取客户管理列表
   * @return:
   */

  getCustomerList() {
    return jsRoutes.controllers.CustomerController.getCustomerList();
  }

  /**
   * @description: 账户分配(多选)
   * @return:
   */
  assignCustomer() {
    return jsRoutes.controllers.CustomerController.assignCustomer();
  }

  /**
   * @description: 账户分配
   * @return:
   */
  assignAccount() {
    return jsRoutes.controllers.CustomerController.assignAccount();
  }

  /**
   * @description: 跟进记录详情
   * @return:
   */
  searchRecord() {
    return jsRoutes.controllers.CustomerController.searchRecord();
  }

  /**
   * @description: 添加跟进记录
   * @return:
   */
  addCustomerRecord(customerId) {
    return jsRoutes.controllers.AccountController.addCustomerRecord(customerId);
  }

  /**
   * @description: 账户列表
   * @return:
   */
  accountSearch() {
    return jsRoutes.controllers.AccountController.search();
  }

  findAllAccount() {
    return jsRoutes.controllers.AccountController.findAllAccount();
  }

  /**
   * @description: 二次开户
   * @return:
   */
  againRegistration(customerId) {
    return jsRoutes.controllers.AccountController.againRegistration(customerId);
  }

  /**
   * @description: 获取账户数量
   * @return:
   */
  assignCheckAccount() {
    return jsRoutes.controllers.CustomerController.assignCheckAccount();
  }

  /**
   * @description 获取企点的JsTicket
   * @return {*}
   */
  getJsTicket() {
    return jsRoutes.controllers.CallCenterController.getJsTicket();
  }

  /*
   * @description: 查询清洗状态对应的原因标签
   */
  searchLeadReasonTag() {
    return jsRoutes.controllers.LeadController.searchLeadReasonTag();
  }

  /**
   * @description: 更新原因标签
   */
  updateAgencyLeadTag() {
    return jsRoutes.controllers.AgencyController.updateAgencyLeadTag();
  }

  /**
   * @description: 开户单批量分配处理人查询列表
   */
  getOperatorsAuthorized() {
    return jsRoutes.controllers.RegistrationTicketController.getOperatorsAuthorized();
  }

  /**
   * @description: 开户单批量分配
   */
  transferNextHandlers() {
    return jsRoutes.controllers.RegistrationTicketController.transferNextHandlers();
  }

  /**
   * @description: 商机复制
   */
  copyPotential(leadId) {
    return jsRoutes.controllers.PotentialController.copyPotential(leadId);
  }

  /**
   * @description: 获取线索当前阶段
   */
  getLeadStatus(leadId) {
    return jsRoutes.controllers.LeadController.getLeadStatus(leadId);
  }

  /**
   * @description: 查询企点坐席详情
   */
  getNewSeatUseDetails(callCenterId) {
    return jsRoutes.controllers.AgencyController.getSeatUseDetails(callCenterId);
  }

  /**
   * @description: 线索分析查询
   */
  searchLeadReport() {
    return jsRoutes.controllers.LeadReportAnalysisController.searchLeadReport();
  }

  /**
   * @description: 商机转化分析
   */
  searchPotentialReport() {
    return jsRoutes.controllers.PotentialReportAnalysisController.searchPotentialReport();
  }

  /**
   * @description: 订单上线分析
   */
  searchOrderReport() {
    return jsRoutes.controllers.OrderReportAnalysisController.searchOrderReport();
  }

  /**
   * @description: 企微客户列表
   */
  searchRelation() {
    return jsRoutes.controllers.OnlineSalesController.searchRelation();
  }

  /**
   * @description: 企微标签配置
   */
  getCorpTagConfig() {
    return jsRoutes.controllers.OnlineSalesController.getCorpTagConfig();
  }

  /**
   * @description: 企微关联
   */
  onlineSalesBind() {
    return jsRoutes.controllers.OnlineSalesController.bind();
  }

  /**
   * @description: 坐席统计报表
   */
  searchSeatReport() {
    return jsRoutes.controllers.SeatReportAnalysisController.searchSeatReport();
  }

  /**
   * @description: 坐席统计报表下载
   */
  downloadSeatReportExcel() {
    return jsRoutes.controllers.DownloadExcelController.downloadSeatReportExcel();
  }
}

export default PlayWebApi;
